<div
  class="growth-revision-filter-holder"
  [ngClass]="{
    'data-review-filter--active': dataViewFilterVisible,
    'growth-revision-filter--disable': disable
  }"
>
  <label class="filter-label">Growth / Revisions</label>
  <button
    nz-button
    nz-popover
    nzPopoverTrigger="click"
    [nzPopoverContent]="contentTemplate"
    nzPopoverPlacement="bottomLeft"
    [(nzPopoverVisible)]="dataViewFilterVisible"
    (nzPopoverVisible)="popoverChange()"
    class="filter-btn"
    style="width: 100%; height: 25px;padding-left: 0px;"
  >
    <span [innerHTML]="selectedDataView"></span>
    <span></span>
    <i nz-icon [nzType]="popoverOpen ? 'up' : 'down'" class="arrow"></i>
  </button>

  <ng-template #contentTemplate>
    <ul nz-menu class="list-style rev-option-list">
      <li nz-menu-item style="height: 80px;">
        <nz-checkbox-group
          [(ngModel)]="checkOptions"
          (ngModelChange)="chkboxOptChange()"
        ></nz-checkbox-group>
      </li>
      <li nz-menu-divider></li>
      <li nz-menu-item style="height: 115px; display: inline-grid;">
        <label style="color: #222; font-size: 14px;line-height: initial"
          >Revisions</label
        >
        <label style="color: #979797; font-size: 12px;line-height: initial"
          >Chart View for Revisions</label
        >
        <nz-radio-group
          [(ngModel)]="radioValue"
          class="radio"
          (ngModelChange)="radioValChange()"
        >
          <label nz-radio nzValue="1y" class="radio-opt">&Delta; 1 Years</label>
          <label nz-radio nzValue="2y" class="radio-opt">&Delta; 2 Years</label>
          <!-- <label nz-radio nzValue="custom" class="radio-opt"
              ><span
                >&Delta;
                <nz-date-picker
                  [(ngModel)]="customDate"
                  [nzDisabledDate]="disabledCustomDate"
                  (ngModelChange)="onDateChange()"
                  nzPlaceHolder="Custom Days"
                  [ngStyle]="{
                    'border-bottom': inValidCustomDate
                      ? '1px solid red'
                      : '1px solid #979797'
                  }"
                ></nz-date-picker></span
              ><i
                nz-icon
                nzType="exclamation-circle"
                nzTheme="outline"
                style="color: red"
                *ngIf="inValidCustomDate"
              ></i
            ></label> -->
        </nz-radio-group>
      </li>
      <li nz-menu-divider></li>
      <li class="buttons">
        <div
          class="err-msg-holder"
          *ngIf="invalidDataview"
          style="width: 110px; line-height: 1"
        >
          <i
            nz-icon
            nzType="exclamation-circle"
            nzTheme="outline"
            style="color: red"
          ></i>
          <span class="err-msg">{{ dvErrMsg }}</span>
        </div>
        <div class="button-container">
          <button nz-button class="btn" (click)="onResetDataView()">
            Reset
          </button>
          <button nz-button nzType="primary" (click)="applyDataView()">
            Apply
          </button>
        </div>
      </li>
    </ul>
  </ng-template>
</div>
